(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tiles = document.querySelectorAll('.tile-showcase__tile');

  if (!tiles.length) return;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    tiles.forEach(function (tile) {
      tile.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.35 }
  );

  tiles.forEach(function (tile) {
    observer.observe(tile);
  });
})();
